export default api => ({
    getAll: () => api.get('/preset-searches'),
    create: preset => api.post('/preset-searches', preset),

    getById: id => api.get(`/preset-searches/${id}`),
    updateById: (id, preset) => api.patch(`/preset-searches/${id}`, preset),
    deleteById: id => api.delete(`/preset-searches/${id}`),
})
